import { render, staticRenderFns } from "./ChatWithDoctor.vue?vue&type=template&id=0c57bcb4"
import script from "./ChatWithDoctor.vue?vue&type=script&lang=js"
export * from "./ChatWithDoctor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports